<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">응찰안내</h2>
            </div>

            <div class="tab-wrap">
                <v-tabs :value="tab" grow show-arrows center-active class="tab tab--underline">
                    <v-tab v-for="{ value, text } in tabs" :key="value" :to="`/how-to/${value}`">
                        <span>{{ text }}</span>
                    </v-tab>
                </v-tabs>
            </div>

            <v-tabs-items :value="tab" touchless>
                <!-- S: 회원가입 -->
                <how-to-bid-join />
                <!-- E: 회원가입 -->
                <!-- S: 프리뷰 -->
                <how-to-bid-preview />
                <!-- E: 프리뷰 -->
                <!-- S: 온라인경매 -->
                <how-to-bid-online />
                <!-- E: 온라인경매 -->
                <!-- S: 라이프경매 -->
                <how-to-bid-live />
                <!-- E: 라이프경매 -->
                <!-- S: 유의사항 -->
                <how-to-bid-notice />
                <!-- E: 유의사항 -->
                <!-- S: 낙찰 및 수수료 -->
                <how-to-bid-success />
                <!-- E: 낙찰 및 수수료 -->
                <!-- S: 픽업 및 배송 -->
                <how-to-bid-delivery />
                <!-- E: 픽업 및 배송 -->
            </v-tabs-items>
        </v-container>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import HowToBidJoin from "@/components/client/ko/how-to/how-to-bid-join.vue";
import HowToBidPreview from "@/components/client/ko/how-to/how-to-bid-preview.vue";
import HowToBidOnline from "@/components/client/ko/how-to/how-to-bid-online.vue";
import HowToBidLive from "@/components/client/ko/how-to/how-to-bid-live.vue";
import HowToBidNotice from "@/components/client/ko/how-to/how-to-bid-notice.vue";
import HowToBidSuccess from "@/components/client/ko/how-to/how-to-bid-success.vue";
import HowToBidDelivery from "@/components/client/ko/how-to/how-to-bid-delivery.vue";
import { HOW_TO_BID_TABS } from "@/assets/variables";
const tabs = Object.values(HOW_TO_BID_TABS);

export default {
    components: {
        ClientPage,
        HowToBidJoin,
        HowToBidPreview,
        HowToBidOnline,
        HowToBidLive,
        HowToBidNotice,
        HowToBidSuccess,
        HowToBidDelivery,
    },
    props: {
        tab: { type: String, default: HOW_TO_BID_TABS.JOIN.value },
    },
    data() {
        return {
            tabs,
        };
    },
    mounted() {
        this.syncPath();
    },
    methods: {
        syncPath() {
            const path = `/how-to/${this.tab}`;
            if (this.$route.path !== path) this.$router.replace(path);
        },
    },
};
</script>

<style lang="scss" scoped>
</style>